/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Meta_DescriptionInputs */

const en_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule a private golf lesson with Mark Egly online in Des Moines, Iowa.`)
};

const es_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenda una lección privada de golf con Mark Egly en línea en Des Moines, Iowa.`)
};

const de_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereinbaren Sie online eine private Golfstunde mit Mark Egly in Des Moines, Iowa.`)
};

const zh_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在爱荷华州得梅因在线与 Mark Egly 安排私人高尔夫课程。`)
};

const ar_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احجز درس غولف خاصاً مع Mark Egly عبر الإنترنت في Des Moines, Iowa.`)
};

const fr_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planifiez une leçon de golf privée avec Mark Egly en ligne à Des Moines, Iowa.`)
};

const vi_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt lịch buổi học golf riêng với Mark Egly trực tuyến tại Des Moines, Iowa.`)
};

const sw_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ratibu somo la kibinafsi la gofu na Mark Egly mtandaoni huko Des Moines, Iowa.`)
};

const th_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นัดเวลาเรียนกอล์ฟแบบส่วนตัวกับ Mark Egly ทางออนไลน์ในเมืองดิมอยน์ รัฐไอโอวา`)
};

const bs_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zakažite privatnu lekciju golfa s Markom Eglyjem online u Des Moinesu, Iowa.`)
};

const ja_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines, IowaでMark Eglyのプライベートゴルフレッスンをオンラインで予約できます。`)
};

const ko_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines, Iowa에서 Mark Egly와 함께하는 개인 골프 레슨을 온라인으로 예약하세요.`)
};

const pt_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agende uma aula de golfe privada com Mark Egly online em Des Moines, Iowa.`)
};

const it_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizza una lezione di golf privata con Mark Egly online in Des Moines, Iowa.`)
};

const sv_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boka en privat golflektion med Mark Egly online i Des Moines, Iowa.`)
};

const nl_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan een privé golfles met Mark Egly online in Des Moines, Iowa.`)
};

const da_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book en privat golflektion med Mark Egly online i Des Moines, Iowa.`)
};

const nb_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestill en privat golftime med Mark Egly på nett i Des Moines, Iowa.`)
};

const fi_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varaa yksityinen golftunti Mark Eglyltä verkossa – Des Moines, Iowa.`)
};

const pl_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaplanuj prywatną lekcję golfa z Mark Egly online w Des Moines, Iowa.`)
};

const ru_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запланируйте частный урок гольфа с тренером Mark Egly онлайн в Des Moines, Iowa.`)
};

const tr_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines, Iowa'da Mark Egly ile online özel golf dersi planlayın.`)
};

const hi_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des Moines, Iowa में Mark Egly के साथ निजी गोल्फ़ पाठ ऑनलाइन बुक करें।`)
};

const id_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadwalkan pelajaran golf pribadi dengan Mark Egly online di Des Moines, Iowa.`)
};

const ms_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempah pelajaran golf persendirian dengan Mark Egly dalam talian di Des Moines, Iowa.`)
};

const cs_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naplánujte si soukromou lekci golfu s Mark Egly online v Des Moines, Iowa.`)
};

const el_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Προγραμματίστε ένα ιδιωτικό μάθημα γκολφ με Mark Egly σε απευθείας σύνδεση σε Des Moines, Iowa.`)
};

const he_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קבעו אונליין שיעור גולף פרטי עם Mark Egly ב-Des Moines, Iowa.`)
};

const af_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespreek 'n privaat gholfles by Mark Egly aanlyn in Des Moines, Iowa.`)
};

const hu_booking_meta_description = /** @type {(inputs: Booking_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglalj online privát golfórát Mark Eglynél – Des Moines, Iowa.`)
};

/**
* | output |
* | --- |
* | "Schedule a private golf lesson with Mark Egly online in Des Moines, Iowa." |
*
* @param {Booking_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_meta_description = /** @type {((inputs?: Booking_Meta_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Meta_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_meta_description(inputs)
	if (locale === "de") return de_booking_meta_description(inputs)
	if (locale === "zh") return zh_booking_meta_description(inputs)
	if (locale === "ar") return ar_booking_meta_description(inputs)
	if (locale === "fr") return fr_booking_meta_description(inputs)
	if (locale === "vi") return vi_booking_meta_description(inputs)
	if (locale === "sw") return sw_booking_meta_description(inputs)
	if (locale === "th") return th_booking_meta_description(inputs)
	if (locale === "bs") return bs_booking_meta_description(inputs)
	if (locale === "ja") return ja_booking_meta_description(inputs)
	if (locale === "ko") return ko_booking_meta_description(inputs)
	if (locale === "pt") return pt_booking_meta_description(inputs)
	if (locale === "it") return it_booking_meta_description(inputs)
	if (locale === "sv") return sv_booking_meta_description(inputs)
	if (locale === "nl") return nl_booking_meta_description(inputs)
	if (locale === "da") return da_booking_meta_description(inputs)
	if (locale === "nb") return nb_booking_meta_description(inputs)
	if (locale === "fi") return fi_booking_meta_description(inputs)
	if (locale === "pl") return pl_booking_meta_description(inputs)
	if (locale === "ru") return ru_booking_meta_description(inputs)
	if (locale === "tr") return tr_booking_meta_description(inputs)
	if (locale === "hi") return hi_booking_meta_description(inputs)
	if (locale === "id") return id_booking_meta_description(inputs)
	if (locale === "ms") return ms_booking_meta_description(inputs)
	if (locale === "cs") return cs_booking_meta_description(inputs)
	if (locale === "el") return el_booking_meta_description(inputs)
	if (locale === "he") return he_booking_meta_description(inputs)
	if (locale === "af") return af_booking_meta_description(inputs)
	if (locale === "hu") return hu_booking_meta_description(inputs)
	return en_booking_meta_description(inputs)
});